import { render } from "./MemberImport.vue?vue&type=template&id=6b12c794&scoped=true"
import script from "./MemberImport.vue?vue&type=script&lang=js"
export * from "./MemberImport.vue?vue&type=script&lang=js"

import "./MemberImport.vue?vue&type=style&index=0&id=6b12c794&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b12c794"]])

export default __exports__